import { SxProps } from '@mui/material';

export const compactDisabledInputSx = {
  '& .MuiInputBase-root': {
    px: '0 !important',
  },
  '& .MuiInputBase-input': {
    px: '0 !important',
    textAlign: 'center !important',
  },
  '& .MuiInputBase-root.Mui-disabled': {
    pointerEvents: 'none',
    backgroundColor: 'common.inputDisabledBackground',
    color: 'text.primary',
    '& .MuiInputBase-input': {
      WebkitTextFillColor: 'inherit !important',
      color: 'inherit !important',
    },
  },
} satisfies SxProps;
